import { makeStyles, Typography } from "@material-ui/core";
import { TEXT } from "Clients/ACCB/ACCBTheme";
import React from "react";

// Values reaching these cards are not reliably clean: besides null/undefined,
// the API hands back the literal strings "null"/"undefined"/"None" for unset
// profile fields, which is why cards used to read "Phone: null". Anything that
// carries no information is normalised to an empty string.
const BLANK = ["", "null", "undefined", "none", "nan", "-"];

export function normalisePartyValue(value) {
  if (value === null || value === undefined || typeof value === "boolean") {
    return "";
  }

  // Values were historically concatenated with a trailing ", " so they would run
  // together into an address line; strip that separator and any stray space.
  const text = String(value).trim().replace(/[,\s]+$/, "");

  return BLANK.includes(text.toLowerCase()) ? "" : text;
}

const useStyles = makeStyles(() => ({
  row: {
    display: "block",
    padding: "3px 0",
    overflowWrap: "anywhere",
    wordBreak: "normal",
  },
  // The label is the quieter half of the pair - it repeats on every row and you
  // scan past it to the value. Same token for both would flatten that.
  label: {
    fontWeight: 600,
    color: TEXT.secondary,
  },
  value: {
    color: TEXT.primary,
  },
}));

export default function PartyField({ label, value, className }) {
  const classes = useStyles();
  const text = normalisePartyValue(value);

  return (
    <Typography
      className={className ? `${classes.row} ${className}` : classes.row}
    >
      <span className={classes.label}>{label}:</span>{" "}
      <span className={classes.value}>{text}</span>
    </Typography>
  );
}
